export default "__VITE_ASSET__a2209254__"